import React, { useState, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SFGridContainer, SFGridItem, SFStack } from "../grid";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { SFArrowRightIcon } from "../icons";
import SFTypography from "../typography";

const StyledContainer = styled("div")(({ theme }) => ({
  "& .MuiPaper-root": {
    border: `1px solid ${theme.palette.grey225.main}`,
    borderRadius: "4px",
    boxSizing: "border-box",
    boxShadow: "none",
    backgroundColor: theme.palette.grey50.main,
  },
  "& .Mui-expanded": {
    backgroundColor: "white",
  },
  "& .MuiAccordionSummary-content": {
    margin: "0px !important",
    padding: theme.spacing(1.5),
  },
  "& .MuiButtonBase-root": {
    padding: 0,
  },
}));

const StyledIcon = ({icon}) => {
  return React.createElement(icon, {size:"large", color:"grey400"});
};

const ImageContainer = styled("div")(({ theme }) => ({
  width: theme.spacing(7),
  height: theme.spacing(7),
  backgroundColor: theme.palette.grey200.main,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "4px",
  [theme.breakpoints.between("md", "lg")]: {
    display: "none",
  },
  [theme.breakpoints.only("xs")]: {
    display: "none",
  },
  size:"large",
  color:"grey400"
}));

const ArrowContainer = styled("div")(() => ({
  paddingTop: "1px",
}));

export const SFToggleCard = (props) => {
  const [toggle, setToggle] = useState(false);
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    if (props.enabled) {
      setEnabled(true);
    }
  }, []);
  const toggleCard = (e, expanded) => {
    if (enabled) {
      setToggle((prev) => {
        return !prev;
      });
    }
  };

  return (
    <StyledContainer>
      <Accordion
        expanded={toggle}
        onChange={toggleCard}
        onClick={props.onClick}
      >
        <AccordionSummary
          expandIcon={
            props.hasIcon && (
              <ExpandMoreIcon sx={{ fontSize: 40 }} color="grey300" />
            )
          }
        >
          <SFGridContainer
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
          >
            <SFGridItem xs="auto">
              <ImageContainer>
                <StyledIcon icon={props.icon}></StyledIcon>
              </ImageContainer>
            </SFGridItem>
            <SFGridItem xs>
              <SFStack>
                <SFTypography variant="body2bold">{props.title}</SFTypography>
                <SFTypography variant="body2">
                  {props.subTitle}
                </SFTypography>
              </SFStack>
            </SFGridItem>
          </SFGridContainer>
        </AccordionSummary>
        <AccordionDetails>
          {props.data && props.data.length > 0
            ? props.data.map((d, index) => (
              <SFStack direction="row" key={index} alignItems="flex-start">
                <ArrowContainer>
                  <SFArrowRightIcon size="small" color="grey400" />
                </ArrowContainer>
                <SFTypography variant="body1">
                  {d}
                </SFTypography>
              </SFStack>
            ))
            : props.noDataLabel && (
              <SFTypography variant="body1">{props.noDataLabel}</SFTypography>
            )}
        </AccordionDetails>
      </Accordion>
    </StyledContainer>
  );
};

SFToggleCard.defaultProps = {
  enabled: false,
};

SFToggleCard.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.string),
  icon: PropTypes.elementType,
  hasIcon: PropTypes.bool,
  enabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default SFToggleCard;
